<template lang="pug">

.tabs(:class="_class")
  .tabs-menu(:class="_class + '-menu'")
    .container
      .tabs-menu__list
        .tabs-menu__item(v-for="tab, index in tabs" :key="index"  :data-subtitle="tab.subtitle" :class="[{ 'active' : tab.active }, _class + '-menu__item']")
          a.tabs-menu__link.title.title_size_m(
            @click.prevent="selectTab(tab);"
            :class="_class + '-menu__link'"
            href="#") {{tab.name }}

  .tabs-content(:class="_class + '-content'" :style="{ height : height }" ref="tabsContent")
    .container
      slot

</template>

<script>

export default {
  props: ['type'],
  data () {
    return {
      tabs: [],
      height: 0
    }
  },
  computed: {
    _class () {
      return this.type
    }
  },
  mounted () {
    this.tabs = this.$children
    setTimeout(() => {
      this.height = this.tabs[0].$el.clientHeight + 'px'
    })
    this.$root.$on('rowToggled', value => {
      this.tabs.forEach(element => {
        if (element.active) {
          setTimeout(() => {
            this.height = element.$el.clientHeight + 'px'
          }, 200)
        }
      })
    })
  },
  methods: {
    selectTab (selectedTab) {
      this.tabs.forEach((tab, i) => {
        tab.active = tab.name === selectedTab.name
        if (tab.active) {
          this.height = tab.$el.clientHeight + 'px'
          this.$nextTick(function () {
            let el = document.querySelector('.tabs-menu__item.active')
            let scrollTo = el.offsetLeft
            let scroller = document.querySelector('.tabs-menu__list')
            scroller.scrollLeft = scrollTo - 20 // margin
          })
        }
      })
    },
    handleResize (event) {
      this.tabs.forEach(element => {
        if (element.active) {
          this.height = element.$el.clientHeight + 'px'
        }
      })
    }
  },
  created () {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style lang="sass">

</style>



// WEBPACK FOOTER //
// src/components/tabs.vue